import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyCaH1L5hQrJr1ozLm9W2ZCD5ZMljwcg5Hg',
  authDomain: 'av-architect.firebaseapp.com',
  projectId: 'av-architect',
  storageBucket: 'av-architect.firebasestorage.app',
  messagingSenderId: '70030922134',
  appId: '1:70030922134:web:5d80dc7766fd66b78f0db7',
  measurementId: 'G-0EQK6MK26X',
};

const firebaseApp = initializeApp(firebaseConfig);

export const auth = getAuth(firebaseApp);
export const db = getFirestore(firebaseApp);
